export default "__VITE_ASSET__CA8BxBYh__"